<template>
  <el-aside
    class="side-menu"
    @mouseenter.native="mouseIn = true"
    @mouseleave.native="mouseIn = false"
    :class="{ collapse: menuCollapse, 'not-pined': !menuPined }"
  >
    <div class="aside-head">
      <div class="input-wrapper">
        <i v-if="menuCollapse" class="el-icon-search"></i>
        <el-input v-else v-model="searchText" clearable prefix-icon="el-icon-search"></el-input>
      </div>
    </div>
    <div class="aside-body" v-ps>
      <div v-for="item in group" :key="item.value">
        <div
          v-if="
            item.value === 'manage' &&
              filteredMenuList.filter(menuF => menuF.value.slice(0, 8).includes(item.value)).length
          "
          class="function"
        >
          <el-divider></el-divider>
          <div class="function-manage" v-if="!menuCollapse">
            功能管理
          </div>
          <div class="split">
            <el-divider></el-divider>
          </div>
        </div>
        <el-menu
          :collapse-transition="false"
          :collapse="menuCollapse"
          @select="handleSelect"
          :default-openeds="defaultOpens"
          :default-active="defaultActive"
        >
          <template
            v-for="menu in filteredMenuList.filter(menuF =>
              menuF.value.slice(0, 8).includes(item.value)
            )"
          >
            <el-submenu v-if="menu.children" :index="menu.value" :key="menu.value">
              <div slot="title" class="content">
                <svg-icon :icon-class="'company_' + menu.icon" style="margin-right: 5px"></svg-icon>
                <span>{{ menu.label }}</span>
              </div>
              <el-menu-item-group>
                <el-menu-item v-for="item in menu.children" :key="item.value" :index="item.value">
                  <div class="content">
                    <svg-icon
                      v-if="item.hasOwnProperty('icon')"
                      :icon-class="'company_' + menu.icon"
                      style="margin-right: 5px"
                    ></svg-icon>
                    <span
                      class="label"
                      :style="
                        item.hasOwnProperty('icon') ? 'margin-left: 2px;' : 'margin-left: 11px;'
                      "
                    >
                      {{ item.label }}
                    </span>
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item v-else :index="menu.value" :key="menu.value">
              <div class="content">
                <svg-icon :icon-class="'company_' + menu.icon" style="margin-right: 5px"></svg-icon>
                <span slot="title">{{ menu.label }}</span>
              </div>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
    <div class="aside-tail">
      <el-button
        v-if="!menuPined"
        icon="el-icon-s-unfold"
        type="text"
        @click="setMenuPined(true)"
      ></el-button>
      <el-button v-else icon="el-icon-s-fold" type="text" @click="setMenuPined(false)"></el-button>
    </div>
  </el-aside>
</template>

<script>
import { menuMap } from "@/views/Company/Manage/Layout/static"

export default {
  name: "SideMenu",
  components: {},
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menuMap,
      mouseIn: false,
      menuPined: true,
      searchText: "",
      group: [
        {
          value: "company",
          label: "基本信息"
        },
        { value: "manage", label: "功能管理" }
      ]
    }
  },
  computed: {
    defaultMenu() {
      if (!this.searchText) return []
      return this.filteredMenuList?.map(subMenuList => subMenuList.value)
    },
    defaultOpens() {
      return this._.isEmpty(this.defaultMenu) ? [] : this.defaultMenu
    },
    defaultActive() {
      return this._.isEmpty(this.defaultMenu)
        ? this._.keys(this.menuMap).includes(this.$route.name)
          ? this.menuMap[this.$route.name]
          : this.$route.name
        : null
    },
    menuCollapse() {
      return !this.menuPined && !this.mouseIn
    },
    filteredMenuList() {
      if (!this.searchText) return this.menuList
      return this.menuList
        .map(menu => {
          return Object.assign({}, menu, {
            children: menu.children?.filter(subMenu => {
              return subMenu.label.includes(this.searchText)
            })
          })
        })
        .filter(menu => menu.label.includes(this.searchText) || !this._.isEmpty(menu.children))
    }
  },
  methods: {
    setMenuPined(pined) {
      this.menuPined = pined
      if (!pined) {
        this.mouseIn = false
      }
      this.$emit("setMenuPined", pined)
    },
    handleSelect(routeName) {
      if (this.$route.name === routeName) return
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-common: 18px;
.side-menu {
  box-shadow: 0 1px 4px 0 rgba(192, 196, 204, 1);
  z-index: 10;
  display: flex;
  flex-flow: column;
  height: 100%;
  transition: 0.5s;
  width: 240px !important;
  background: white;
  span {
    font-size: $font-size-main;
  }
  .el-button {
    color: $color-icon;
    font-size: 22px;
  }
  .icon-setting {
    font-size: 22px;
    margin-left: auto;
  }
  .svg-icon {
    font-size: $font-size-title-second;
    cursor: pointer;
  }
  .icon-search {
    color: $color-font-second;
  }
  .aside-head {
    padding: 10px 20px;
    .title-wrapper {
      display: flex;
      align-items: center;
      height: 30px;
    }
    .input-wrapper {
      padding-top: 4px;
      img {
        height: 32px;
      }
    }
  }
  .aside-body {
    flex: auto;
    ::v-deep .el-menu {
      border: none;
      .el-submenu__title {
        &:hover,
        &.is-active {
          outline: 0;
          background-color: $color-bg-select;
        }
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        div {
          margin-right: 20px;
          overflow: hidden;
          display: flex;
          align-items: center;
          span {
            margin-left: 2px;
            @include ellipsis;
          }
        }
        .el-submenu__icon-arrow {
          font-size: 16px;
        }
      }
      .el-menu-item {
        &:hover,
        &.is-active {
          outline: 0;
          background-color: $color-bg-select;
        }
        display: flex;
        height: 40px;
        line-height: 40px;
        div {
          overflow: hidden;
          display: flex;
          align-items: center;
          span {
            margin-left: 2px;
            @include ellipsis;
          }
        }
      }
      .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(0deg);
      }
      .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
        transform: rotateZ(-90deg);
      }
      .el-menu-item-group__title {
        display: none;
      }
    }
  }
  .aside-tail {
    text-align: center;
  }
  &.not-pined {
    position: absolute;
    height: 100%;
  }
  &.collapse {
    width: $navbar-height !important;
    .aside-head {
      padding: 10px calc((#{$navbar-height} - #{$font-size-common}) / 2);
      .font-topic-bold {
        display: none;
      }
    }
    ::v-deep .el-menu {
      left: -3px;
      .el-submenu__title {
        div {
          margin-right: 0;
        }
      }
      .el-submenu.is-active {
        .content .svg-icon {
          color: #409eff;
        }
      }
    }
  }
  .el-submenu {
    .el-submenu__title,
    .content .svg-icon {
      flex-shrink: 0;
      color: $color-font-second;
    }
    .el-menu-item {
      &.is-active {
        .content .svg-icon {
          color: #409eff;
        }
      }
    }
  }
  .function {
    .function-manage {
      padding: 15px 20px 0 20px;
      font-size: 12px;
      color: #909399;
    }
    ::v-deep .el-divider--horizontal {
      height: 8px;
      background-color: #f5f7fa;
      margin: 0;
    }
    .split {
      padding: 10px 20px;
      ::v-deep .el-divider--horizontal {
        height: 1px;
        background-color: #f5f7fa;
        margin: 0;
      }
    }
  }
}
</style>
